var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedConsentsSearchFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 64c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64C0 28.654 28.654 0 64 0c35.346 0 64 28.654 64 64z",
    fill: "#F8F8FB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.743,
    cy: 60.743,
    r: 15.743,
    fill: "#fff",
    stroke: "#666D92",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#666D92",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "m82.672 83-10.87-10.869M55.252 55.252l10.733 10.733m0-10.733L55.252 65.985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedConsentsSearchFail);
export default __webpack_public_path__ + "static/media/med_consents_search_fail.4b1d0a82a0000596ccef5e3261fa4ae0.svg";
export { ForwardRef as ReactComponent };